var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiSrCheckCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 16,
    height: 12,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM6.44071 11.873L9.74877 15.2676L17.5593 7.25361C17.7176 7.09122 17.9322 7 18.1561 7C18.3799 7 18.5946 7.09122 18.7529 7.25361C18.9111 7.41604 19 7.63632 19 7.866C19 8.09568 18.9111 8.31596 18.7529 8.4784L10.9432 16.4924C10.7864 16.6533 10.6003 16.781 10.3954 16.8681C10.1905 16.9552 9.97095 17 9.74919 17C9.52743 17 9.30785 16.9552 9.10298 16.8681C8.89811 16.781 8.71197 16.6533 8.5552 16.4924L5.24714 13.0978C5.0889 12.9353 5 12.7151 5 12.4854C5 12.2557 5.0889 12.0354 5.24714 11.873C5.40544 11.7106 5.6201 11.6194 5.84393 11.6194C6.06775 11.6194 6.28242 11.7106 6.44071 11.873Z",
    fill: "#0C6E3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrCheckCircleFilled);
export default __webpack_public_path__ + "static/media/fi-sr-check-circle-filled.47da36c0ce00f8c9937a57ecbdd207de.svg";
export { ForwardRef as ReactComponent };